import { useNavigate } from 'react-router-dom';
import { ReactComponent as SearchIcon } from '@/assets/steam/search-icon.svg';
import './Users.scss';
import { useEffect, useState, useRef } from 'react';
import BackIcon from '@/assets/rewise/back-icon.svg';
import { useGetUsersList } from '../api/getProducts';
import { ArchiveIcon } from '@heroicons/react/outline';
import { User, Location, UserRole, State } from '../types/indes';
import { showNotification } from '@/utils/notificationUtils';
import { Loader } from '@/components/Loader/Loader';
import noDataAnimation from '@/assets/animation/loading.json';
import Lottie from 'lottie-react';
import Filter, { ReactComponent as ProductIcon } from '@/assets/steam/product.svg';
import Delete from '@/assets/steam/delete.svg';
import View from '@/assets/steam/view.svg';
import Edit from '@/assets/steam/edit.svg';
import { TableData } from '@/components/Table/TableData';
import { PageHeader } from '@/components/PageHeaders/PageHeader';
import Utils from '@/utils/util';
import InitialsAvatar from 'react-initials-avatar';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import AddNewUser from '../components/addNewUser';
import { useGetStateList, useGetUserRoleList } from '../api/getRefrences';
import { useDeleteUser } from '../api/deleteUser';
import { FilterMenu } from '@/components/Elements/FilterMenu';

export const Users = () => {
  const [usersList, setUsersList] = useState<User[]>([]);
  const [isAddNewUser, setIsAddNewUser] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [tableCurrentIndex, setTableCurrentIndex] = useState(1);
  const perPage = 10;
  const [searchString, setSearchString] = useState('');
  const [filteredList, setFilteredList] = useState<User[]>([]);
  const [productDetails, setProductDetails] = useState<User>();
  const useGetUsersMutation = useGetUsersList();
  const useGetUserRoleMutation = useGetUserRoleList();
  const useGetStateMutation = useGetStateList();
  const useDeleteUserMutation = useDeleteUser();
  const [roles, setRoles] = useState<UserRole[]>([]);
  const [states, setStates] = useState<State[]>([]);
  const [editUserData, setEditUserData] = useState<any>(null);

  useEffect(() => {
    getUsersList(1, true);
    getUserRoleList();
    getStateList();
  }, []);


  const getUserRoleList = async () => {
    const res = await useGetUserRoleMutation.mutateAsync({
      search: ''
    });
    if (res) {
      setRoles(res.list);
    }
  };

  const deleteUser = async (id:any) =>{
    const res = await useDeleteUserMutation.mutateAsync({
      id
    });
    if (res) {
      getUsersList(1, true);
    }
  }

  const getStateList = async () => {
    const res = await useGetStateMutation.mutateAsync({
      search: ''
    });
    if (res) {
      setStates(res.list);
    }
  };

  const getUsersList = async (pageIndex?: number, reset = false, filter?: any, isOnlyEdit?: any) => {
    const res = await useGetUsersMutation.mutateAsync({
      page: pageIndex ? pageIndex : tableCurrentIndex,
      perPage: perPage,
      search: searchString,
      filter,
    });

    setTotalPages(res.totalPages);
    setTotalRecords(res.total);
    if(isOnlyEdit){
      setUsersList(res.list);
      if(pageIndex)setTableCurrentIndex(pageIndex);
      if (searchString) {
        setFilteredList(res.list);
      }
    }else if (reset) {
      setUsersList(res.list);
      //setTableCurrentIndex(1);
      if(pageIndex){
        setTableCurrentIndex(pageIndex);
      }else{
        setTableCurrentIndex(tableCurrentIndex);
      }
      if (searchString) {
        setFilteredList(res.list);
      }
    } else {
      setUsersList(usersList.concat(res.list));
      if(pageIndex){
        setTableCurrentIndex(pageIndex);
      }else{
        setTableCurrentIndex(tableCurrentIndex);
      }
    }
  };

  const searchUser = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchString = e.target.value;
    setSearchString(searchString);
    const res = await useGetUsersMutation.mutateAsync({
      page: 1,
      perPage: perPage,
      search: searchString,
    });
    setUsersList(res.list);
    if (searchString) {
      setFilteredList(res.list);
    } else {
      setFilteredList([]);
    }
    setTotalPages(res.totalPages);
    setTotalRecords(res.total);
  };

  const actualList = filteredList.length ? filteredList : usersList;

  const onTableStateChange = (pageIndex: number) => {
    if (totalPages >= pageIndex) {
      getUsersList(pageIndex, true);
      setTableCurrentIndex(pageIndex);
    }
  };

  const getStates = (location: any) => {
    if (location && location.length > 0) {
      const states = location.map((loc: any) => loc.state);
      const uniqueStates = Array.from(new Set(states.map((state: any) => state.id)))
        .map((id) => states.find((state: any) => state.id === id)?.name);

      const firstThreeStates = uniqueStates.slice(0, 2);
      const remainingCount = uniqueStates.length - 2;

      return {
        firstThreeStates,
        remainingCount: remainingCount > 0 ? remainingCount : 0,
      };
    }
    return { firstThreeStates: [], remainingCount: 0 };
  };

 
  return (
    <>

      <div className="users-list-container">
        <PageHeader title='User Management' description='' />
        <div className='search-container'>
          <div className='search-filter-container'>

            <span className="search-content">
              <SearchIcon />
              <input
                type="text"
                id="simple-search"
                placeholder="Search User by Name, Email or Phone"
                onChange={searchUser}
                className="steam-search"
              />
            </span>
            <div>
            <div className="action-btn">
              <FilterMenu roles={roles} states={states} options={[ ]} onRoleSelect={(filter)=>{
                if(filter){
                  getUsersList(1, true,filter)
                }else{
                  getUsersList(1, true)
                }
               }}/>
              </div>
            </div>

          </div>
          <div className='add-user-container'>
            <button className='steam-button button-dark' onClick={() => { setIsAddNewUser(true) }}>+ Add new user</button>

          </div>
        </div>
        <div className="users-list petsked-table">
          {useGetUsersMutation.isLoading && !searchString && (
            <div className="h-full w-full flex items-center justify-center  ">
              <Lottie className="loading-loader-class" animationData={noDataAnimation} />
            </div>
          )}

          <TableData<User>
            data={actualList}
            columns={[
              {
                title: 'Name',
                field: 'name',
                Cell({ entry }) {
                  return (
                    <div className="users-container">
                      <div>
                        <InitialsAvatar name={entry && entry.name ? entry.name : 'SA'} className="avatar" />
                      </div>
                      <div className="user-details-container">

                        <div className="user-tab-name">
                          <div className="name">{entry?.name}</div>
                          <div className="email">{entry?.email}</div>
                        </div>
                      </div>
                    </div>
                  );
                },
              },
              {
                title: 'Designation',
                field: 'userRole',
                Cell({ entry: { userRole } }) {
                  return (
                    <div className="table-user-role">
                      {userRole.name}{' '}

                    </div>
                  );
                },
              },
              {
                title: 'Contact no',
                field: 'phone',
                Cell({ entry: { phone } }) {
                  return (
                    <div className="table-contact">
                      {phone}

                    </div>
                  );
                },
              },
              {
                title: 'State assigned',
                field: 'phone',
                Cell({ entry: { location } }) {
                  const { firstThreeStates, remainingCount } = getStates(location);

                  return (
                    <div className="table-contact">
                      <div className='fix-width'>
                        {firstThreeStates.join(', ')}
                      </div>
                      {remainingCount > 0 && (
                        <span className='show-count'>
                          +{remainingCount}
                        </span>
                      )}
                    </div>
                  );
                },
              },
              {
                title: 'City assigned',
                field: 'productAccess',
                Cell({ entry: { location } }) {
                  const { firstThreeCity, remainingCount } = Utils.getCities(location);

                  return (
                    <div className="table-contact">
                      <div className='fix-width'>
                        {firstThreeCity.join(', ')}
                      </div>
                      {remainingCount > 0 && (
                        <span className='show-count'>
                          +{remainingCount}
                        </span>
                      )}
                    </div>
                  );
                },
              },
              {
                title: 'Added on',
                field: 'createdAt',
                Cell({ entry: { createdAt } }) {
                  return (
                    <div className="table-date">
                      {Utils.formatDate(
                        createdAt
                      )}
                    </div>
                  );
                },
              },

              {
                title: 'Action',
                field: 'id',
                Cell({ entry }) {
                  return (
                    <div className="user-btn-container">
                     
                      <div className="edit-btn" onClick={() => { setEditUserData(entry); setIsAddNewUser(true) }} >
                        <img src={Edit} />
                      </div>
                      <div
                        className="view-btn"
                        onClick={() => {
                          deleteUser(entry.id)
                        }}
                      >
                        <img src={Delete} />
                      </div>
                    </div>
                  );
                },
              },
            ]}
            tableInitialState={{
              tableTotalRecords: totalPages,
              tablePageIndex: tableCurrentIndex,
            }}
            onTableStateChange={onTableStateChange}
            showPagination={true}
            isDataLoading={useGetUsersMutation?.isLoading}
          />
        </div>

        <AddNewUser onConfirm={() => {setIsAddNewUser(false);getUsersList(tableCurrentIndex, false, null, true) }} onClose={() => { setIsAddNewUser(false); setEditUserData(null) }} open={isAddNewUser} role={roles} states={states} editUserData={editUserData} />


      </div>

    </>
  );
};
